module.exports = __webpack_public_path__ + "img/mem_coupon_font5.772b9905.jpg";